import { CellContext } from "@tanstack/react-table"
import classNames from "classnames"

import { ApiTypes, UITypes } from "types"

import styles from "./index.module.scss"

interface Props {
  cell: CellContext<UITypes.TableBodyRow, UITypes.TableBodyCell>
}

const getStatusLabel = (type: string): string => {
  switch (type) {
    case "new":
      return "NEW"

    case "pending":
      return "PENDING"

    case "denied":
      return "DENIED"
    case "confirmed":
      return "CONFIRMED"

    case "packed":
      return "PACKED"

    case "shipping":
      return "SHIPPING"
    case "archived":
      return "FULFILLED"
    case "canceled":
      return "CANCELED"

    default:
      return type
  }
}

export const StatusOfWHOrder = ({ cell }: Props) => {
  const items = cell.row.original.rowSettings.item as ApiTypes.Model.WHManagerOrderNewItem[] | undefined
  const isExpanded = cell.row.getIsExpanded()

  if (!items || items.length === 0 || (isExpanded && items.length > 1)) {
    return null
  }

  const statuses = items.map(item => item.status).filter(Boolean)

  if (statuses.length === 0) {
    return null
  }

  return (
    <div className={styles.statusContainer}>
      {statuses.map((status, index) => {
        const type = String(status)
        const label = getStatusLabel(type)

        return (
          <span
            key={`${status}-${index}`}
            className={classNames(styles.alertStatus, {
              [styles[type]]: type ? true : false,
            })}
          >
            {label}
          </span>
        )
      })}
    </div>
  )
}
